function timer () {
  const clock_elms = window.clockdown_elms;

  clock_elms?.forEach(elm => {
    const currentDate = new Date();
    const targetDate = new Date(elm.time);
    const distance = targetDate - currentDate;

    if (distance < 0) return;

    const days = Math.floor(distance / 1000 / 60 / 60 / 24);
    const hours = Math.floor(distance / 1000 / 60 / 60) % 24;
    const minutes = Math.floor(distance / 1000 / 60) % 60;
    const seconds = Math.floor(distance / 1000) % 60;

    const daysElemNumb = document.querySelector(`${elm.class} .clock-days .clock-number`);
    const hoursElemNumb = document.querySelector(`${elm.class} .clock-hours .clock-number`);
    const minutesElemNumb = document.querySelector(`${elm.class} .clock-minutes .clock-number`);
    const secondsElemNumb = document.querySelector(`${elm.class} .clock-seconds .clock-number`);

    if (daysElemNumb) daysElemNumb.innerHTML = days < 10 ? `0${days}` : days;
    if (hoursElemNumb) hoursElemNumb.innerHTML = hours < 10 ? `0${hours}` : hours;
    if (minutesElemNumb) minutesElemNumb.innerHTML = minutes < 10 ? `0${minutes}` : minutes;
    if (secondsElemNumb) secondsElemNumb.innerHTML = seconds < 10 ? `0${seconds}` : seconds;

    const daysElemText = document.querySelector(`${elm.class} .clock-days .clock-text`);
    const hoursElemText = document.querySelector(`${elm.class} .clock-hours .clock-text`);
    const minutesElemText = document.querySelector(`${elm.class} .clock-minutes .clock-text`);
    const secondsElemText = document.querySelector(`${elm.class} .clock-seconds .clock-text`);

    if (daysElemText) daysElemText.innerHTML = days === 1 ? 'Día' : 'Días';
    if (hoursElemText) hoursElemText.innerHTML = hours === 1 ? 'Hora' : 'Horas';
    if (minutesElemText) minutesElemText.innerHTML = minutes === 1 ? 'Minuto' : 'Minutos';
    if (secondsElemText) secondsElemText.innerHTML = seconds === 1 ? 'Segundo' : 'Segundos';
  })
};

setInterval(timer, 1000);
